import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1513.82658,1278.28019 C1417.05523,1278.28019 1331.19312,1322.04548 1272.41158,1389.81109 L708.211527,1064.07412 C720.019171,1030.57634 727.719809,995.025067 727.719809,957.420286 C727.719809,922.510729 720.660891,889.397987 710.393374,857.825372 L1274.2084,532.345085 C1332.98993,598.827257 1417.95364,641.69414 1513.82658,641.69414 C1691.06959,641.69414 1834.68648,498.077247 1834.68648,320.834236 C1834.68648,143.591224 1691.06959,-0.0256687924 1513.82658,-0.0256687924 C1336.58356,-0.0256687924 1192.96667,143.591224 1192.96667,320.834236 C1192.96667,356.000481 1200.02559,389.241567 1210.42145,420.814182 L646.734769,746.294469 C587.953235,679.555609 502.861188,636.560382 406.859905,636.560382 C229.616893,636.560382 86,780.177275 86,957.420286 C86,1134.6633 229.616893,1278.28019 406.859905,1278.28019 C500.294309,1278.28019 583.461196,1237.85184 642.114387,1174.06489 L1209.65139,1501.72703 C1199.7689,1532.52958 1192.96667,1564.87226 1192.96667,1599.1401 C1192.96667,1776.38311 1336.58356,1920 1513.82658,1920 C1691.06959,1920 1834.68648,1776.38311 1834.68648,1599.1401 C1834.68648,1421.89708 1691.06959,1278.28019 1513.82658,1278.28019",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconShareSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconShareSolid, _Component);

  var _super = _createSuper(IconShareSolid);

  function IconShareSolid() {
    _classCallCheck(this, IconShareSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconShareSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconShare",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconShareSolid.displayName = "IconShareSolid";
  return IconShareSolid;
}(Component);

IconShareSolid.glyphName = 'share';
IconShareSolid.variant = 'Solid';
IconShareSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconShareSolid;
export { IconShareSolid };